import { observer } from "mobx-react-lite";
import { CustomButton } from "ui";

import { useStores } from "stores";
import { ConfirmationModal } from "components/ActionModals/ConfirmationModal";
import { ReactNode } from "react";
import { ButtonProps } from "antd";

type Props = {
  calledQuery: () => Promise<any>;
  text: string | ReactNode;
  successText: string;
  btnProps?: ButtonProps;
  tooltip?: string;
  modalProps?: {
    width?: string;
    title?: string;
    approveButtonText?: string;
    onSuccess?: () => void;
  };
};

export const ConfirmBtn = observer(({ calledQuery, text, successText, btnProps, tooltip, modalProps }: Props) => {
  const { actionModals } = useStores();

  function showModalHandle() {
    actionModals.open(
      () => (
        <ConfirmationModal
          text={text}
          successText={successText}
          buttonText={modalProps?.approveButtonText ?? "Подтвердить"}
          calledQuery={() => calledQuery()}
          onSuccess={modalProps?.onSuccess}
        />
      ),
      {
        ...modalProps,
      }
    );
  }
  return <CustomButton size="xlarge" onClick={showModalHandle} {...btnProps} tooltip={tooltip} />;
});
